import "../../styles/AppointmentConfirmation.css";
import "es6-shim";
import * as React from 'react';
import { IAppointmentConfirmationProps } from "./Types";
import { LateAppointmentScenario } from "./Scenarios/LateAppointmentScenario";
import { ValidOnlyAppointmentScenario } from "./Scenarios/ValidOnlyAppointmentScenario";
import { FutureOnlyAppointmentScenario } from "./Scenarios/FutureOnlyAppointmentScenario";
import { ValidAndFutureAppointmentScenario } from "./Scenarios/ValidAndFutureAppointmentScenario";
import { 
    ISuccessfulAppointmentConfirmPopupProps,
    SuccessfulAppointmentConfirmedPopup
} from "./SuccessfulAppointmentConfirmPopup";
import { useMediaQuery } from "../../hooks/useMediaQuery.hook";
import TimerManager from "../../services/TimerManager";
import { ClientEventScreen } from "../../dtos/KioskDtos.dtos";
import { MultiSiteSuccessfulAppointmentConfirmPopup } from "./MultiSiteSuccessfulAppointmentConfirmPopup";

export const AppointmentConfirmation = (props: IAppointmentConfirmationProps) => {
    const orientation = useMediaQuery();

    React.useEffect(() => TimerManager.setCurrentScreen(ClientEventScreen.ExistingAppointmentConfirmation), [])

    const successfulAppointmentConfirmProps: ISuccessfulAppointmentConfirmPopupProps = {
        isAppointmentConfirmed: props.isAppointmentConfirmed,
        textString: props.textString,
        message: props.textString.messagesInstructions.ProcedeToWaitingRoomInstruction,
        return: props.return
    }

    let contentToRender = null;
    if (props.appointments.lateAppointments && props.appointments.lateAppointments.any()) {
        contentToRender = <LateAppointmentScenario {...props} orientation={orientation} />
    } else if (props.appointments.validAppointments && props.appointments.validAppointments.any()) {
        if (props.appointments.futureAppointments.isEmpty()) {
            contentToRender = <ValidOnlyAppointmentScenario {...props} />
        } else {
            contentToRender = <ValidAndFutureAppointmentScenario {...props} />
        }
    } else if (props.appointments.futureAppointments.any()) {
        contentToRender = <FutureOnlyAppointmentScenario {...props} />
    }
    return (
        <>
            <div className="row col-md-12">
                <div className="col-md-12 header">
                    <div>
                        <h1 className="clinic-header">{props.textString.titles.AppointmentConfirmationTitle}</h1>
                    </div>
                </div>
            </div>
            <div>
                {props.isMultiSiteEnabled
                    ? <MultiSiteSuccessfulAppointmentConfirmPopup {...props} />
                    : SuccessfulAppointmentConfirmedPopup(successfulAppointmentConfirmProps)
                }
                {contentToRender}
            </div>
        </>
    );
}



// WEBPACK FOOTER //
// ./src/components/AppointmentConfirmation/AppointmentConfirmation.component.tsx